import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './core/appConfig.service';
import { Observable } from 'rxjs';
import { ParamTutitionCalculationDto } from '../models/tuitionCalculation/paramTutitionCalculationDto';

@Injectable({
  providedIn: 'root'
})
export class TuitionCalculationService {

  private url_high_tuition = '';
  private url_modification_tuition = '';
  private url_cancellation_tuition = '';
  private url_list_pattern_modification = '';
  private url_lits_pattern_cancellation = '';


  constructor(private http: HttpClient, private configService: AppConfigService) {
    this.url_high_tuition = this.configService.apiUrl + "/enrollments/calculate-registration-cost";
    this.url_modification_tuition = this.configService.apiUrl + "/enrollments/calculate-registration-cost/update";
    this.url_cancellation_tuition = this.configService.apiUrl + "/enrollments/calculate-registration-cost/annulment";
    this.url_list_pattern_modification = this.configService.apiUrl + "/enrollments/filter/modification?"
    this.url_lits_pattern_cancellation = this.configService.apiUrl + "/enrollments/filter/cancellation?"
  }

  public consultHighTuition(paramTutitionCalculationDto: ParamTutitionCalculationDto): Observable<any> {
    return this.http.post<any>(this.url_high_tuition, paramTutitionCalculationDto);
  }

  public consultModificationTuition(paramTutitionCalculationDto: ParamTutitionCalculationDto): Observable<any> {
    return this.http.post<any>(this.url_modification_tuition, paramTutitionCalculationDto);
  }

  public consultCancellationTuition(paramTutitionCalculationDto: ParamTutitionCalculationDto): Observable<any> {
    return this.http.post<any>(this.url_cancellation_tuition, paramTutitionCalculationDto);
  }

  public consultListPatternModification(typology: string): Observable<any> {
    const params = new HttpParams()
      .set('sizePage', 50)
      .set('order', 1)
      .set('page', 1)
      .set('typology', typology)
      .set('orderField', '');
    return this.http.get<any>(this.url_list_pattern_modification, { params });
  }

  public consultListPatternCancellation(typology: string): Observable<any> {
    const params = new HttpParams()
      .set('sizePage', 50)
      .set('order', 1)
      .set('page', 1)
      .set('typology', typology)
      .set('orderField', '');
    return this.http.get<any>(this.url_lits_pattern_cancellation, { params });
  }


}
